/**
 * Physical frame extrusion depth (m) for the outer shell; matches `makeFrameGeometry`.
 */
export const MIRROR_FRAME_DEPTH = 0.3;

/**
 * Virtual depth of the space inside the portal (LEDs, layers, rear mirror).
 * It does not have to equal frame depth: increasing it enlarges spacing between
 * layers while the physical frame itself stays relatively short.
 *
 * Higher multiplier → larger Z gap between each `depthLayers` slice (text bands,
 * perimeter LED rails). Needed so "Double bars" at consecutive boundaries do not
 * read as one fused stripe when perspective stacks reflections.
 */
export const MIRROR_VIRTUAL_DEPTH = MIRROR_FRAME_DEPTH * 11;
